;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { useEffect, useState } from 'react';
import { Button, ModalBody, ModalFooter } from 'reactstrap';
import { useFormik } from 'formik';

import { logSentryError } from '../../../utils/logSentry';

import { useUser } from '../../../contexts/UserContext';
import { saveCandidate } from '../../../api/candidate';
import FormAlert from '../../forms/FormAlert';
import { FormikInputCheckbox } from '../../forms/inputs';
import { initialValues, validationSchema } from '../../forms/EmailSettings/config';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

type Props = {
  dictionary: Partial<Dictionaries>;
  next: () => void;
  prev: () => void;
};
function ProfileModalEmail({ next, prev, dictionary }: Props): JSX.Element {
  const { candidate, setCandidate } = useUser();
  const { formatMessage } = getI18nUtils(dictionary);
  const [alert, setAlert] = useState<{ type: 'success' | 'warning'; message: string } | null>(null);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async ({ receiveMatchmail }, actions) => {
      setAlert(null);
      try {
        await saveCandidate({ receiveMatchmail }, 'acquaintance');
        setCandidate((prevC) => ({ ...prevC, receiveMatchmail }));
        actions.setSubmitting(false);
        actions.resetForm();
        next();
      } catch (e: any) {
        setAlert({ type: 'warning', message: 'internal-server-error' });
        actions.setSubmitting(false);
        logSentryError(e);
      }
    },
  });

  useEffect(() => {
    formik.setValues({ receiveMatchmail: !!candidate?.receiveMatchmail });
  }, [candidate]);

  const { isSubmitting, handleSubmit } = formik;

  return (
    <>
      <ModalBody>
        <h2 className="mb-4">{formatMessage({ id: 'profile_form_mail_title' })}</h2>

        <fieldset disabled={isSubmitting} aria-busy={isSubmitting}>
          <p>{formatMessage({ id: 'profile_form_mail_intro' })}</p>
          <FormikInputCheckbox
            dictionary={dictionary}
            className="mb-3"
            name="receiveMatchmail"
            formik={formik}
            intlKey="suggested_jobs"
          />
          <p className="mb-2">{formatMessage({ id: 'send_jobsuggestions' })}</p>
        </fieldset>
      </ModalBody>
      <ModalFooter>
        <FormAlert dictionary={dictionary} className="flex-grow-1 mb-2" alert={alert} />
        <Button color="primary" className="mt-5 w-100" onClick={() => handleSubmit()}>
          {formatMessage({ id: 'next' })}
        </Button>
        <Button color="white" className="mt-3 mx-auto d-block" onClick={() => prev()}>
          {formatMessage({ id: 'previous' })}
        </Button>
      </ModalFooter>
    </>
  );
}

export default ProfileModalEmail;
